import React from 'react'
import { Link } from 'react-router-dom'

export default class About extends React.Component {
  render () {
    return (
      <div>
        <h2>About</h2>
        <ul>
          <li><Link to='/'>Home</Link></li>
          <li><Link to='/'>Home</Link></li>
        </ul>
      </div>
    )
  }
}
